'use client';

import { useTranslations } from '../../../i18n/TranslationsProvider';
import CloudinaryHLSVideoEmbed from '../cloudinaryHLSVideoEmbed/CloudinaryHLSVideoEmbed';
import NativeVideoEmbed from '../nativeVideoEmbed/NativeVideoEmbed';
import YouTubeVideoEmbed from '../youTubeVideoEmbed/YouTubeVideoEmbed';
import { useVideoPlayerDetection } from './hooks';
import { VideoEmbedAutoDetectProps } from './types';

export const VideoEmbedAutoDetect = ({
	url,
	cloudinaryHlsEnabled,

	...props
}: VideoEmbedAutoDetectProps) => {
	const { t } = useTranslations();

	const videoPlayerOptions = useVideoPlayerDetection({ url, cloudinaryHlsEnabled });

	switch (videoPlayerOptions?.player) {
		case 'cloudinaryHLS':
			return <CloudinaryHLSVideoEmbed {...props} hlsSrc={videoPlayerOptions.src} />;
		case 'native':
			return <NativeVideoEmbed {...props} src={videoPlayerOptions.src} />;
		case 'youtube':
			return <YouTubeVideoEmbed {...props} url={url} videoId={videoPlayerOptions.videoId} />;
		default:
			return (
				<p className="absolute italic left-0 text-center top-1/2 transform -translate-y-1/2 w-full">
					{t.general.video.videoUrlNotSupported}
				</p>
			);
	}
};

VideoEmbedAutoDetect.displayName = 'VideoEmbed';

export default VideoEmbedAutoDetect;
